import styled from '@eversports/klimt-design-components/styled'
import ExpandableContent from '@eversports/klimt-patterns/ExpandableContent'
import FormattedContent from '@eversports/klimt-primitives/legacy/FormattedContent'

const SmallTextContent = styled('div')`
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.03125rem;

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.03125rem;
    margin-bottom: 1em;
  }

  /* heading sizes mirror the manager's rich text editor (Quill) */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: bold;
    margin-bottom: 1em;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1.17em;
  }

  ul,
  ol {
    padding-left: 1.5em;
    margin-bottom: 1em;

    li {
      line-height: 1.5rem;
    }

    li > p {
      display: inline;
    }
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  a {
    text-decoration: underline;
  }

  & > *:last-child {
    margin-bottom: 0;
  }

  strong,
  b {
    font-weight: bold;
  }

  i,
  em {
    font-style: italic;
  }
`

const MAX_DESCRIPTION_HEIGHT = 84

interface Props {
  description: string
}

const Description = ({ description }: Props) => (
  <ExpandableContent clampedTextHeight={MAX_DESCRIPTION_HEIGHT}>
    <FormattedContent htmlContent={description} WrapperComponent={SmallTextContent} />
  </ExpandableContent>
)

export default Description
